import React, { useState } from 'react';
import { CalendarX, X } from 'lucide-react';

interface PortalGuruModalTidakPresensiPulangProps {
    onClose: () => void;
    onSubmit: (reason: string) => void;
    loading?: boolean;
}

export const PortalGuruModalTidakPresensiPulang: React.FC<PortalGuruModalTidakPresensiPulangProps> = ({ onClose, onSubmit, loading }) => {
    const [reason, setReason] = useState('');
    const [noReason, setNoReason] = useState(false);

    const handleSubmit = () => {
        if (noReason) onSubmit('Tidak ada alasan');
        else if (reason.trim()) onSubmit(reason);
    };

    const isSubmitDisabled = !noReason && !reason.trim();

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300 text-center">
                <div className="absolute top-4 right-4">
                    <button onClick={onClose} className="p-1 rounded-full text-gray-500 hover:bg-gray-100 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <div className="mx-auto w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mb-4 ring-8 ring-red-50">
                    <CalendarX size={48} className="text-red-600" />
                </div>

                <h3 className="text-xl font-bold text-[#111813] tracking-tight mb-2">Tidak Presensi Pulang</h3>
                <p className="text-sm text-[#63886f] mb-6 leading-relaxed">
                    Sesi sebelumnya telah kedaluwarsa atau melewati batas waktu. Status kepulangan Anda akan dicatat sebagai <b>Tidak Presensi Pulang</b>.
                </p>

                <div className="text-left mb-6">
                    <label className="block text-sm font-semibold text-[#111813] mb-2" htmlFor="reason">Alasan Tidak Presensi</label>
                    <textarea
                        className="w-full rounded-xl border-gray-200 bg-gray-50 text-[#111813] focus:border-red-500 focus:ring-red-500 text-sm p-3 min-h-[100px] resize-none outline-none ring-1 ring-transparent transition-all"
                        id="reason"
                        placeholder="Tuliskan alasannya di sini..."
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        disabled={noReason || loading}
                    />
                    <div className="flex items-center mt-3">
                        <input
                            className="h-4 w-4 rounded border-gray-300 text-red-500 focus:ring-red-500 cursor-pointer"
                            id="no-reason-checkbox"
                            type="checkbox"
                            checked={noReason}
                            onChange={(e) => setNoReason(e.target.checked)}
                            disabled={loading}
                        />
                        <label className="ml-2 text-sm text-[#63886f] cursor-pointer select-none" htmlFor="no-reason-checkbox">Tidak ada alasan</label>
                    </div>
                </div>

                <button
                    onClick={handleSubmit}
                    disabled={isSubmitDisabled || loading}
                    className={`w-full py-3.5 font-bold rounded-xl shadow-lg transition-all active:scale-[0.98] ${
                        isSubmitDisabled || loading
                            ? 'bg-gray-200 text-gray-400 shadow-none cursor-not-allowed'
                            : 'bg-red-600 hover:bg-red-700 text-white shadow-red-600/25'
                    }`}
                >
                    {loading ? 'Menyimpan...' : 'Kirim & Simpan'}
                </button>
            </div>
        </div>
    );
};
